// import JS files
import '../kickstart';
// import './graphic';
import './scroller';
import './pop-ups';

import { h, render } from 'preact';
import Timeline from '../timeline';

render(<Timeline />, document.getElementById('timeline'));
